import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { JobRole,getJobRoleDetails, jobRolePermissions, JobRoleTable, jobRoleSafety, SafetyPositionsVM, UserOverviewModel, JobPositionsForms } from '../../entities/global/model';
import { CustomerSelectItem, JobsiteSelectItem } from '../../modules/setup-equipment/setup-equipment.model';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UserAccessType } from '../../modules/CustomEval/custom-eval.model';
import { GenericIdName } from '../../modules/GET_NEW_UI/setup-implement/setup-implement.model';

@Injectable()
export class UserService {
    private readonly API_BASE = 'api/user/';
    private readonly GET_USER_JOB_ROLES = this.API_BASE + 'GetUserJobRoles';
    private readonly GET_CUSTOMER_LIST = 'api/setupequipment/GetCustomerList';
    private readonly GET_JOBSITE_LIST = 'api/setupequipment/GetJobsiteList';

    private _jobRoles: BehaviorSubject<JobRole[]> = new BehaviorSubject([]);
    private _jobRolesLoaded: boolean = false;
    public jobRoles: Observable<JobRole[]> = this._jobRoles.asObservable();

    constructor(private _http: HttpClient) { }

    public getUserJobRoles(): Observable<JobRole[]> {
      if (!this._jobRolesLoaded) {
        this._http.get(this.GET_USER_JOB_ROLES)
          .pipe(catchError(this.handleError))
          .subscribe(jobRoles => {
            this._jobRoles.next(<JobRole[]>jobRoles);
            this._jobRolesLoaded = true;
          });
      }
      return this.jobRoles;
    }
    


    
    //load Job roles
    public GetAllJobRoles(): Observable<getJobRoleDetails> {
     
      return this._http.get<getJobRoleDetails>('api/user/GetAllJobRoles').pipe(catchError(this.handleError));
    }

    //LoadAccesibleSystem
    public GetAllAcessibleSystem(): Observable<GenericIdName[]> {
     
      return this._http.get<GenericIdName[]>('api/user/GetAcessibleSystem').pipe(catchError(this.handleError));
    }

       //LoadAccesibleSaferty
       public GetSafetyEnabled(): Observable<any> {
     
        return this._http.get('api/user/HasSafetyEnabled').pipe(catchError(this.handleError));
      }
  
      public CheckAddNewIspectionMenuAccess(): Observable<any> {
        
        return this._http.get('api/user/CheckAddNewIspectionMenuAccess').pipe(catchError(this.handleError));
      }

      public CheckFindIspectionMenuAccess(): Observable<any> {
        
        return this._http.get('api/user/CheckFindIspectionMenuAccess').pipe(catchError(this.handleError));
      }


    //Get JobRole Details

    public getJobroleDetails( Id: number): Observable<getJobRoleDetails> {
      let options ={
        params:new HttpParams().set('Id', Id.toString())
      };
        return this._http.get<getJobRoleDetails>('api/user/getJobroleDetails', options).pipe(catchError(this.handleError));
      }
//load job role table

public GetUserTable( Id: number): Observable<JobRoleTable[]> {
  let options ={
    params:new HttpParams().set('Id', Id.toString())
  };
    return this._http.get<JobRoleTable[]>('api/user/GetUserTable', options).pipe(catchError(this.handleError));
  }
 //add new job role
 
 public addNewJobroleDetails(model: getJobRoleDetails): Observable<any> {
  return this._http.post('api/user/addNewJobroleDetails', model).pipe(catchError(this.handleError));
}


//update job role details

public updateJobroleDetails(model: getJobRoleDetails): Observable<any> {
  return this._http.post('api/user/updateJobroleDetails', model).pipe(catchError(this.handleError));
}

//Delete job role details
public deleteJobroleDetails(Id: number): Observable<any> {
  let options ={
    params:new HttpParams().set('Id', Id.toString())
  };
  return this._http.get('api/user/deleteJobroleDetails', options).pipe(catchError(this.handleError));
}

public isAllowEditByUserId(): Observable<any> {

  return this._http.get('api/user/isAllowEditByUserId').pipe(catchError(this.handleError));
}

//Get menu for slelection jobrole

public GETMenuForSlectedJobRole(Id: number): Observable<jobRolePermissions> {
  let options ={
    params:new HttpParams().set('Id', Id.toString())
  };
  return this._http.get<jobRolePermissions>('api/user/GETMenuForSlectedJobRole', options).pipe(catchError(this.handleError));
}




//update active status
public updateActiveStatus(PermissionMneuData:jobRolePermissions): Observable<any> {
  return this._http.post('api/user/updateJobRoleMenuActiveStatus', PermissionMneuData).pipe(catchError(this.handleError));
}


    public getCustomerList(): Observable<CustomerSelectItem[]> {
      return this._http.get<CustomerSelectItem[]>(this.GET_CUSTOMER_LIST).pipe(catchError(this.handleError));
    }

    public getJobsiteList(customerId: number): Observable<JobsiteSelectItem[]> {
      let options = {
        params: new HttpParams().set('customerId', customerId.toString())
      };
      return this._http.get<JobsiteSelectItem[]>(this.GET_JOBSITE_LIST, options).pipe(catchError(this.handleError));
    }


    
    public getUserAccessType(): Observable<UserAccessType> {
      // return this._http.get(this.GetUserAccessTypeApiAddress).share().map(
      //     (response: Response) => <UserAccessType>response.json()).catch(this.handleError);
      return this._http.get<UserAccessType>('api/user/GetAccessLevelForUser').pipe(catchError(this.handleError));
  }

  public getUserDefaultDigitlFormCategory(): Observable<number> {
    // return this._http.get(this.GetUserAccessTypeApiAddress).share().map(
    //     (response: Response) => <UserAccessType>response.json()).catch(this.handleError);
    return this._http.get<number>('api/user/GetDefaultFormCategoryForUser').pipe(catchError(this.handleError));
}


public jobRolePermissionsforSafetyVM(): Observable<jobRoleSafety[]> {
 
  return this._http.get<jobRoleSafety[]>('api/user/GETMenuForSlectedJobRoleforSafety').pipe(catchError(this.handleError));
}

//Job Positions
public AddNewJobPosition(info: SafetyPositionsVM): Observable<any> {
  return this._http.post('api/user/AddNewJobPosition', info).pipe(catchError(this.handleError));
}
public UpdateJobPosition(info: SafetyPositionsVM): Observable<any> {
  return this._http.post('api/user/UpdateJobPosition', info).pipe(catchError(this.handleError));
}

public DeleteJobPosition(info: SafetyPositionsVM): Observable<any> {
  return this._http.post('api/user/DeleteJobPosition', info).pipe(catchError(this.handleError));
}

public getSafetyJobPositins(): Observable<SafetyPositionsVM[]> {
 
  return this._http.get<SafetyPositionsVM[]>('api/user/getSafetyJobPositins').pipe(catchError(this.handleError));
}

public getActiveSafetyJobPositins(): Observable<SafetyPositionsVM[]> {
 
  return this._http.get<SafetyPositionsVM[]>('api/user/getActiveSafetyJobPositins').pipe(catchError(this.handleError));
}

public GetAllUsersForJobPosition(positionID: number): Observable<UserOverviewModel[]> {
  let options ={
    params:new HttpParams().set('positionID', positionID.toString())
  };
  return this._http.get<UserOverviewModel[]>('api/User/GetAllUsersForJobPosition', options).pipe(catchError(this.handleError));
}



public UpdateSafetyUSerPosition(info: UserOverviewModel[], positionID:number ): Observable<any> {
  let options ={
    params:new HttpParams().set('positionID', positionID.toString())
  };
  return this._http.post("api/user/UpdateSafetyUSerPosition", info, options).pipe(catchError(this.handleError));
} 


public GetAllFormsJobPosition(positionID: number): Observable<JobPositionsForms[]> {
  let options ={
    params:new HttpParams().set('positionID', positionID.toString())
  };
  return this._http.get<JobPositionsForms[]>('api/User/GetAllFormsJobPosition', options).pipe(catchError(this.handleError));
}

public UpdateSafetFormPosition(info: JobPositionsForms[], positionID:number ): Observable<any> {
  let options ={
    params:new HttpParams().set('positionID', positionID.toString())
  };
  return this._http.post("api/user/UpdateSafetFormPosition", info, options).pipe(catchError(this.handleError));
}  

  
  public checkDuplicateInspection(): Observable<string> {
       return this._http.get<string>('api/User/CheckDuplicateInspection').pipe(catchError(this.handleError));
        
    }
 public HasShowAlert(): Observable<any> {
     
        return this._http.get('api/user/HasShowAlert').pipe(catchError(this.handleError));
      }
// public UpdateSafetFormPosition(info:JobPositionsForms[]) {
//   return this._http.post('api/User/UpdateSafetFormPosition', info).share().map(
//       (response: Response) => <boolean>response.json()).catch(this.handleError);
// }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}
